import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {ActivatedRoute} from '@angular/router';
import {WorkHistoryScreensManager} from './work-history-screens-manager.service';
import {WorkService} from '../../../../domain/model/work/history/work.service';
import {Work} from '../../../../domain/model/work/history/work.model';
import {AddressModel} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../domain/model/common/mappers/address-mapper.class';
import moment = require('moment');

@Component({
    template: require('./work-history-screen.component.html')
})
export class WorkHistoryScreenComponent {

    constructor(readonly workService: WorkService,
                countryService: CountryService,
                readonly route: ActivatedRoute,
                readonly screensManager: WorkHistoryScreensManager) {
        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => this.states = states.map(s => s.name));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _addressMapper = new AddressMapper();

    countries: Array<string> = [];
    states: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    durationDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(1, 'year')
    };
    durationFromMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);
    durationToMonthPickerModel = new MonthPickerComponentModel(this.durationDateConstrains);

    positionHeldOptions = [
        '',
        'Active-Physician',
        'Inactive-Physician',
        'Temp-Physician',
        'Director/Supervisor',
        'Administrative',
        'Research'
    ];

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<Work>({
        initialDataModel: new Work(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            return this.workService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: Work) => {
            return this.workService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.index !== 1 ? this.workService.doesCurrentUserModelEntryExist(this.index).map(r => !r) : Observable.of(false)
    });

    get model(): Work {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.address, addressModel);
    }

    handleUpToPresentDurationChange() {
        if (this.model.duration.upToPresent) this.model.duration.to = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/history/work-history-screen.component.ts